export default __webpack_public_path__ + "static/media/stopList.a9721b94.svg";